export const issuerMapping = (issuer: string, page?: string): string | unknown => {
  switch (issuer) {
    case 'arvaltozas':
    case 'arvaltsimple':
      return 'arvaltozas.hu';
    default:
      return page;
  }
};

export const BASE_TITLE = 'Parola Webáruház';
